<template>
  <div class="row">
    <div class="col-12">
      <DataTable
        :value="machines"
        :lazy="true"
        :paginator="true"
        :rows="per_page"
        :rows-per-page-options="[10, 25, 50]"
        :total-records="inventory_total_machines"
        :loading="loading"
        :row-hover="true"
        @page="onPage($event)"
        @sort="onSort($event)"
        ref="datatable"
        data-key="id"
        class="p-datatable-gridlines p-datatable-sm"
      >
        <template #empty> Nenhum equipamento</template>
        <template #loading> Carregando</template>
        <ColumnGroup type="header">
          <Row>
            <Column
              header="Identificação do equipamento"
              header-class="bg-warning"
              :rowspan="2"
              :colspan="isCompanyMosaic() ? 5 : 6"
            />
            <Column
              header="Sistemas de segurança"
              header-class="bg-info"
              :colspan="safety_systems.length"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Elétrica"
              header-class="bg-secondary"
              :rowspan="2"
              :colspan="2"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Localização"
              header-class="bg-secondary"
              :rowspan="2"
              :colspan="3"
            />
            <Column
              header="Operações"
              header-class="bg-secondary"
              :rowspan="2"
              class="d-print-none"
            />
          </Row>
          <Row>
            <Column
              header="Proteção física"
              header-class="bg-light"
              :colspan="4"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Sistemas tecnológicos"
              header-class="bg-light"
              :colspan="9"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
          </Row>
          <Row>
            <Column class="text-center" header="#" />
            <Column class="text-center d-print-none" header="ID" header-class="bg-light" />
            <Column class="text-center" header="Tag Ambra" />
            <Column class="text-center" header="Tag Equip." />
            <Column class="text-center" header="Equipamento" header-class="bg-light" />
            <Column
              class="text-center"
              header="Capacidade"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Dispositivos mecânicos impedem acesso a zona de risco"
              header-class="th-vertical bg-light"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Proteção fixa junto a partes móveis"
              header-class="th-vertical"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Proteção móvel (carenagem)"
              header-class="th-vertical bg-light"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              class="text-center"
              header="Intertravamento"
              header-class="th-vertical"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Relé de segurança"
              header-class="th-vertical bg-light"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              class="text-center"
              header="CLP elétrica "
              header-class="th-vertical"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Chaves de segurança: eletromecânicas - elétrica"
              header-class="th-vertical bg-light"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              class="text-center"
              header="Sensores indutivos"
              header-class="th-vertical"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Sensores de segurança: sensor eletromagnético"
              header-class="th-vertical bg-light"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Vávulas de segurança: pneumático / hidráulico"
              header-class="th-vertical"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Chaves seletoras"
              header-class="th-vertical bg-light"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="Botão de emergência / Cabo de emergência"
              header-class="th-vertical bg-light"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              header="O acesso ao interior da máquina tem proteção que desligue a mesma quando acessado"
              header-class="th-vertical"
              class="text-center"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              class="text-center"
              header="Voltagem"
              header-class="bg-light th-vertical"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column
              class="text-center"
              header="Aterramento"
              header-class="th-vertical"
              :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
            />
            <Column class="text-center" header="Setor" header-class="bg-light" />
            <Column class="text-center" header="Área" />
            <Column class="text-center" header="Complemento" header-class="bg-light" />
            <Column class="text-center d-print-none" header="Ações" header-class="bg-light" />
          </Row>
        </ColumnGroup>
        <Column class="text-center">
          <template #body="slotProps">
            {{ slotProps.index + 1 }}
          </template>
        </Column>
        <Column class="text-center machine_id d-print-none">
          <template #body="id">
            <button
              class="btn btn-link"
              v-tooltip="'Selecione o equipamento e adicione no mapa'"
              @click="selectMachine(id)"
            >
              <font-awesome-icon
                :icon="['fas', 'map-marked-alt']"
              ></font-awesome-icon>
            </button>
          </template>
        </Column>
        <Column class="text-center" field="ambra_tag"></Column>
        <Column class="text-center" field="machine_tag"></Column>
        <Column class="text-center" field="machine_class.name"></Column>
        <Column
          class="text-center"
          field="capacity"
          :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
        ></Column>
        <Column
          class="text-center"
          v-for="safety_system in safety_systems"
          :key="safety_system.id"
          :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
        >
          <template #body="slotProps">
            <a
              class="text-dark safety-system"
              href="javascript:void(0);"
              :data-safety_system_id="safety_system.id"
              :data-machine_id="slotProps.data.id"
              @click.prevent="onSafetySystemToggle($event)"
            >
              {{ slotProps.data.safety_system[safety_system.id - 1] }}
            </a>
          </template>
        </Column>
        <Column
          class="text-center"
          header="Voltagem"
          field="voltage_name"
          :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
        ></Column>
        <Column
          class="text-center"
          header="Aterramento"
          :style="{ display: isCompanyMosaic() ? 'none' : 'auto' }"
        >
          <template #body="slotProps">
            <span>{{ slotProps.data.has_ground_wire ? 'Sim' : 'Não' }}</span>
          </template>
        </Column>
        <Column class="text-center" header="Setor" field="sector_name"></Column>
        <Column class="text-center" header="Área" field="area_name"></Column>
        <Column class="text-center" header="Complemento" field="complement_name"></Column>
        <Column class="text-center d-print-none">
          <template #body="slotProps">
            <button
              class="btn btn-link"
              v-tooltip="'Clique para excluir'"
              @click="exclui_machine(slotProps.index)"
              v-if="authenticated_user !== 'Cliente somente leitura'"
            >
              <font-awesome-icon
                :icon="['fas', 'trash-alt']" style="cursor: pointer"
              ></font-awesome-icon>
            </button>
          </template>
        </Column>
      </DataTable>

      <!--      <router-link to="/machines/create" class="btn btn-dark mt-3">-->
      <!--        Novo equipamento-->
      <!--      </router-link>-->
    </div>
  </div>
</template>

<script>
  import { computed, onMounted, ref } from 'vue'
  import { useStore } from 'vuex'
  import useSafetySystems from '@/modules/SafetySystem.js'
  import useMachines from '@/modules/Machine.js'
  import { format } from 'date-fns'
  import Column from 'primevue/column'
  import ColumnGroup from 'primevue/columngroup'
  import DataTable from 'primevue/datatable'
  import Row from 'primevue/row'
  import useSwal from '@/modules/Swal.js'
  import { MOSAIC_FERTILIZANTES_ID } from '@/constants/config.constants.js'

  export default {
    components: {
      Column,
      ColumnGroup,
      DataTable,
      Row,
    },
    setup() {
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)
      const authenticated_user = computed(() => store.getters.authenticated_user.user_profile.name)
      const page = ref(1)
      const per_page = ref(10)
      const datatable = ref(null)
      const {
        filtered_machines,
        inventory_total_machines,
        listInventory,
        destroyMachine,
        toggleSafetySystem,
        loading,
      } = useMachines()
      const { safety_systems, listSafetySystems } = useSafetySystems()
      const { showConfirmDeletionSwal, showErrorDialog, showSuccessDialog } =
        useSwal()

      const onPage = (event) => {
        page.value = event.page + 1
        per_page.value = event.rows

        listInventory(selected_order_of_service.value.id, page.value, per_page.value, 12)
      }

      const onSafetySystemToggle = async (event) => {
        var safety_system_id = event.target.dataset.safety_system_id
        var machine_id = event.target.dataset.machine_id

        toggleSafetySystem(safety_system_id, machine_id).then((response) => {
          if (response.data.success.attached.length) {
            event.target.innerHTML = 'Sim'
          } else {
            event.target.innerHTML = 'Não'
          }
        })
      }

      onMounted(async () => {
        await listSafetySystems()

        listInventory(selected_order_of_service.value.id, page.value, per_page.value, 12)
      })

      return {
        datatable,
        loading,
        machines: filtered_machines,
        safety_systems,
        destroyMachine,
        onPage,
        onSafetySystemToggle,
        inventory_total_machines,
        page,
        per_page,
        showConfirmDeletionSwal,
        showErrorDialog,
        showSuccessDialog,
        listInventory,
        selected_company,
        selected_order_of_service,
        authenticated_user
      }
    },
    methods: {
      selectMachine(item) {
        const machine = Object.assign({}, item.data)
        const risk_analysis = Object.assign({}, machine.risk_analyses)[0]
        const marker_selected = {
          id: risk_analysis.id,
          created_at: format(new Date(), 'dd/MM/yyyy H:m:s'),
        }

        localStorage.setItem(
          'selected_machine_table',
          JSON.stringify(marker_selected),
        )
      },
      exclui_machine(item) {
      var machine = this.machines[item]

      var app = this

      this.showConfirmDeletionSwal()
        .then((response) => {
          if (response.isConfirmed) {
            this.destroyMachine(machine, item)
              .then(() => {
                this.showSuccessDialog()
              })
              .catch((error) => {
                this.showErrorDialog(`
                  <small style="color:red">${error?.response?.data?.message || error?.message || 'Erro ao excluir equipamento'}</small>
                `)
              })
          }
        })
        .catch((error) => {
          console.log(error)
        })
      },
      isCompanyMosaic() {
        return this.selected_company.id == MOSAIC_FERTILIZANTES_ID
      },
    },
    watch: {
      selected_order_of_service() {
        this.listInventory(
          this.selected_order_of_service.id,
          this.page,
          this.per_page,
          12
        )
      }
    },
  }
</script>

<style lang="scss" scoped>
  @media print {
    .safety-system {
      text-decoration: none;
    }
  }
  
</style>
